import React, { useState } from "react";
import "../../../assests/css/students/CourseDetail.css";

import {
  ArrowLeft,
  Clock,
  BookOpen,
  User,
  Calendar,
  GraduationCap,
} from "lucide-react";

const CourseDetail = () => {
  const [activeTab, setActiveTab] = useState("overview");

  const courseData = {
    title: "BS (4-years) in Applied Psychology",
    duration: "4 Years",
    department: "Institute of Applied Psychology",
    totalCredits: "134",
    instructors: [
      {
        name: "Dr. Sarah Ahmed",
        designation: "Associate Professor",
        specialization: "Clinical Psychology",
      },
      {
        name: "Dr. Muhammad Hassan",
        designation: "Assistant Professor",
        specialization: "Developmental Psychology",
      },
    ],
    description:
      "The Institute started BS program in 2006. This program comprises of eight semesters and aims to enhance students' knowledge of psychology and its applications.",
    admissionCriteria: "Applicants having Intermediate are eligible",
    sections: {
      morning: "Merit: 54",
      evening: "Merit: 36",
    },
    sessionRegime: {
      semester: "Semester System",
      begins: "Session Begins",
    },
    curriculum: [
      { semester: "I", course: "Introduction to Psychology", creditHours: "3" },
      { semester: "I", course: "Islamic Studies", creditHours: "2" },
      { semester: "II", course: "Environmental Psychology", creditHours: "3" },
      { semester: "II", course: "Expository Writing", creditHours: "3" },
    ],
  };

  const groupedCurriculum = courseData.curriculum.reduce((acc, item) => {
    acc[item.semester] = acc[item.semester] || [];
    acc[item.semester].push(item);
    return acc;
  }, {});

  return (
    <div className="course-detail-container">
      {/* HERO */}
      <div className="course-hero">
        <button className="back-button">
          <ArrowLeft size={18} /> Back to Courses
        </button>
        <h1>{courseData.title}</h1>
        <p>{courseData.department}</p>

        <div className="hero-stats">
          <span>
            <Clock size={16} /> {courseData.duration}
          </span>
          <span>
            <BookOpen size={16} /> {courseData.totalCredits} Credits
          </span>
          <span>
            <GraduationCap size={16} /> Bachelor
          </span>
        </div>
      </div>

      {/* TABS */}
      <div className="tabs">
        <button onClick={() => setActiveTab("overview")}>Overview</button>
        <button onClick={() => setActiveTab("curriculum")}>Curriculum</button>
        <button onClick={() => setActiveTab("instructors")}>Instructors</button>
      </div>

      {/* OVERVIEW */}
      {activeTab === "overview" && (
        <div className="tab-content">
          <h2>About Course</h2>
          <p>{courseData.description}</p>
          <p>
            <strong>Admission:</strong> {courseData.admissionCriteria}
          </p>
        </div>
      )}

      {/* CURRICULUM */}
      {activeTab === "curriculum" && (
        <div className="tab-content">
          {Object.keys(groupedCurriculum).map((sem) => (
            <div key={sem}>
              <h3>Semester {sem}</h3>
              <ul>
                {groupedCurriculum[sem].map((c, i) => (
                  <li key={i}>
                    {c.course} — {c.creditHours}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}

      {/* INSTRUCTORS */}
      {activeTab === "instructors" && (
        <div className="tab-content">
          {courseData.instructors.map((inst, i) => (
            <div key={i}>
              <User /> <strong>{inst.name}</strong>
              <p>{inst.designation}</p>
              <p>{inst.specialization}</p>
            </div>
          ))}
        </div>
      )}

      {/* RIGHT CARD */}
      <div className="enrollment-card">
        <h3>Course Fee</h3>
        <p>PKR 50,000 / Semester</p>
        <Calendar /> Semester System
      </div>
    </div>
  );
};

export default CourseDetail;